import { notificationService } from '../../../../services/notificationService';
import { useWatch } from 'react-hook-form';
import { EpStepContent, EpStepSelect } from '../../components';
import { useTranslation as t } from '../../../../hooks/useTranslation';

export default function NotificationCategoryInput({
  translations,
}: {
  translations: unknown;
}) {
  const NotificationType = useWatch({ name: 'notificationTypeId.inputValue' });
  const { getNotificationTypesCategories } = notificationService;
  const { data: categoryOptions } =
    getNotificationTypesCategories(NotificationType);

  if (categoryOptions?.itens && categoryOptions?.itens.length > 0) {
    return (
      <EpStepContent.Label label={t(translations, 'Incident category') + ' *'}>
        <EpStepSelect
          data={categoryOptions?.itens}
          errorMessage={t(translations, '* Required Fied')}
          registerId={'notificationCategoryId'}
        />
      </EpStepContent.Label>
    );
  }

  return null;
}
